// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Entry-module__wrapper___2xKmS","closeBtn":"Entry-module__closeBtn___28eaC"};